import { computedFrom, customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { Rule, ValidationRules } from 'aurelia-validation';
import { DeviationRequestBase } from 'model/forms/deviation-request';
import { KeywordsService } from 'services/keywords-service';
import { DeviationTeamType } from '../model/business-enums';

@customElement('deviation-request-region-director-panel')
export class DeviationRequestRegionDirectorPanelCustomElement {
  @bindable model: DeviationRequestBase;
  @bindable disabled: boolean;
  @bindable deviationTeamType: DeviationTeamType;
  regionDirectorPanelRules: Rule<DeviationRequestBase, any>[][];

  constructor(private keywords: KeywordsService) {
  }

  modelChanged() {
    this.regionDirectorPanelRules = ValidationRules
      .ensureObject<DeviationRequestBase>().required()
      .ensure(model => model.regionDirector).displayName('Region').required()
      .rules;
  }

  @computedFrom('deviationTeamType')
  get regionDirectors() {
    return this.keywords.getDeviationTeam(this.deviationTeamType).regionDirectors;
  }

  @computedFrom('model.regionDirector')
  get label() {
    const deviationTeam = this.keywords.getDeviationTeam(this.deviationTeamType);
    return [`Region / Regional ${deviationTeam.name} Director`, this.model.regionDirector?.director.name, this.model.regionDirector?.director.mail].filter(l => l != null);
  }

  keywordsItemMatcher = this.keywords.itemsMatch;
}
